import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modules: [],
  airline: "",
  refresh: null,
};

const modulesSlice = createSlice({
  name: "modules",
  initialState,
  reducers: {
    setModules: (state, action) => {
      state.modules = action.payload;
    },
    setModuleSetting: (state, action) => {
      const { moduleKey, name, value } = action.payload;
      const module = state.modules.find((mod) => mod.module === moduleKey);
      if (module)
        module.settings = {
          ...module.settings,
          [name]: value,
        };
    },
    setAirlineInModules: (state, action) => {
      state.airline = action.payload;
    },
  },
});

export const { actions } = modulesSlice;
export const { setModules, setModuleSetting, setAirlineInModules } = actions;

// selectors

export const selModsOBJ = (state) => state.modules.modules;

export const selModByKey = (key) => (state) =>
  state.modules.modules?.find((item) => item.module === key);
export const selAirlineInModule = (state) => state.modules.airline;

const reducer = {
  modules: modulesSlice.reducer,
};

export default reducer;
